export const resolveGateLocale = (
  i18nLanguage: string | undefined,
  navigatorLanguage: string | undefined,
): string => i18nLanguage || navigatorLanguage || 'en';
